module.exports = __webpack_public_path__ + "static/media/features2.c4be401b.jpg";